import React, { useState } from "react";
import styles from './ReportFilterPortDues.module.scss';
import { Badge, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { t } from "i18next";
import Lottie from "react-lottie";
import reportTicket from "../../../assets/animation/animation_report";
import DatePicker from "react-datepicker";
import it from 'date-fns/locale/it';


//general
import UserClass from "../../../General/LocalStorage/UserClass";
import DataManager from "../../../General/DataManager";
import Functions from "../../../General/Functions";



const ReportFilterPortDues = props => {

    const defaultOptionsReport = {
        loop: true,
        autoplay: true,
        animationData: reportTicket
    };
    const [company, setCompany] = useState("");
    const [showModalFilter, setShowModalFilter] = useState(false);
    const [msgModalReport, setMsgModalReport] = useState("");
    const [pdfChecked, setpdfChecked] = useState(true);
    const [csvChecked, setcsvChecked] = useState(false);
    const [dateFrom, setDateFrom] = useState(null);
    const [endDate, setEndDate] = useState(null);


    const [companies, setCompanies] = useState([])
    const [showModalFilterPortDuesSummary, setshowModalFilterPortDuesSummary] = useState(false);
    const [typologyReport, setTypologyReport] = useState("");
    const [dateOfDay, setDateOfDay] = useState("");
    const [dateOfMonth, setDateOfMonth] = useState(null);
    const [reset, setReset] = useState(false);
    const [Document, setDocument] = useState(null)
    const [showCompany, setshowCompany] = useState(true)
    const [showDeparturePort, setshowDeparturePort] = useState(true)

    const [showDestinationPort, setshowDestinationPort] = useState(true)
    const [destination, setDestination] = useState("");

    const [departure, setDeparture] = useState("")
    const [ports, setPorts] = useState([])
    const [disableButton, setDisableButton] = useState(true)
    const [showDocument, setshowDocument] = useState(true)
    const [totFilter, setTotFilter] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState('DEPARTUREDATE');








    React.useEffect(() => {

        getCompanies();



    }, [

    ]);

    const actionSelectFilter = () => {
        /*if (arrFilter !== null){
             setDateOfDay(arrFilter.dateOfDay);
             setTypologyReport(arrFilter.typologyReport);
             setDateOfMonth(arrFilter.dateOfMonth);
             setReset(false);
         }*/
        setShowModalFilter(!showModalFilter);
    };
    const renderOption2 = (obj, idx) => {
        let check = false;
        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            if (company.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };


    const renderOptionPortDeparture = (obj, idx) => {
        let check = false;
        if (typeof (departure) !== 'undefined' && departure !== null && departure !== "") {
            if (departure.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };



    const renderOptionPortDestination = (obj, idx) => {
        let check = false;
        if (typeof (destination) !== 'undefined' && destination !== null && destination !== "") {
            if (destination.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };

    const setTypeCompany = (e) => {
        setDeparture("")
        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {
                setCompany(companies[e.target.selectedIndex - 1]);
                // if(dateFrom!==null && companies[e.target.selectedIndex - 1] !=="" && departure !=="" && companies[e.target.selectedIndex - 1] !==undefined ){
                if (companies[e.target.selectedIndex - 1] !== "" && companies[e.target.selectedIndex - 1] !== undefined) {
                    let instance = UserClass.getInstance();
                    let token = instance.getTokenUser();
                    DataManager.getPorts(companies[e.target.selectedIndex - 1], token).then((result) => {
                        setPorts(result.ports.results)
                    })
                    setshowDeparturePort(false)
                    setDisableButton(false);

                }
                else {
                    setDisableButton(true);
                }
            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    };

    const setTypeDeparture = (e) => {
        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {


                setDeparture(ports[e.target.selectedIndex - 1]);


            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    }

    const setTypeDestination = (e) => {
        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {
                setDestination(ports[e.target.selectedIndex - 1]);

                setshowCompany(false)

            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    }


    const handleChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    const actionReset = () => {
        setReset(true);
        /* let arr = {
             dateOfDay: dateOfDay,
             typologyReport: typologyReport,
             dateOfMonth: dateOfMonth
         };
         setArrFilter(arr);
         setDateOfDay("");
         setTypologyReport("");
         setDateOfMonth(null);*/
        setCompany("")
        setDateFrom("")
        setpdfChecked(true)
        setcsvChecked(false)
        setshowCompany(true)
        setshowDeparturePort(true)
        setshowDestinationPort(true)
        setDisableButton(true)
        setshowDocument(true);
        setTotFilter(0)
        setSelectedFilter('DEPARTUREDATE');



    };
    const actionApply = () => {
        let tot = 0;
        setTotFilter(tot);


        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            setShowModalFilter(false)
            setshowModalFilterPortDuesSummary(true)
            setDocument(null)

            let modeFile = "pdf";
            if (csvChecked == true) {
                modeFile = "csv";
            }
            let instance = UserClass.getInstance();

            let token = instance.getTokenUser();
            let date_from = dateFrom;
            let date_to = dateFrom;


            DataManager.getReportPortDuesSummary(token, modeFile, date_from, date_to, departure, company/*, selectedFilter*/).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['report']) !== 'undefined' && result['report'] !== null) {
                        if (modeFile.toString() === "csv") {
                            const url = window.URL.createObjectURL(new Blob([result['report']]))
                            const link = document.createElement('a')
                            link.href = url;
                            const fileName = `report.csv`;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            setshowModalFilterPortDuesSummary(false)

                        } else {
                            let blob = new Blob([result['report']], {
                                type: "application/pdf"
                            });
                            const url = window.URL.createObjectURL(blob);
                            setDocument(url);
                            setshowDocument(false);
                            setshowModalFilterPortDuesSummary(false)
                        }

                    } else {
                        setshowModalFilterPortDuesSummary(false);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    setshowModalFilterPortDuesSummary(false);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            })



            if (company !== "") {
                tot = tot + 1;

            }
            if (csvChecked || pdfChecked) {
                tot = tot + 1;
            }

            if (dateFrom != "") {
                tot = tot + 1;
            }

            if (departure != "") {
                tot = tot + 1;
            }



            setTotFilter(tot)






        }
        else {
            Functions.alertMsg("Company Field is required");

        }
    };

    const getCompanies = () => {
        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();

        DataManager.verifyLogin
            (token).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['verifylogin']) !== 'undefined' && result['verifylogin'] !== null) {

                        setCompanies(result['verifylogin']['companies'])

                    } else {
                        setshowModalFilterPortDuesSummary(false);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    setshowModalFilterPortDuesSummary(false);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            });
    }


    return (
        <div className={styles.ReportFilterPortDues}>
            <Button
                className="mb-3 ml-10"
                onClick={actionSelectFilter}
                title={t("filters")}
            >
                <i className="fa-solid fa-filter side-menu__icon" /> {t("filters")} {totFilter > 0 ? <Badge bg="secondary">{totFilter.toString()}</Badge> : null}
            </Button>
            <Modal
                {...props}
                size="xs"
                show={showModalFilterPortDuesSummary}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>{msgModalReport}</Modal.Body>
                <Lottie options={defaultOptionsReport}
                    height={200} />
            </Modal>
            <Modal show={showModalFilter}>
                <Modal.Header>
                    <Modal.Title>{t("filters")}</Modal.Title>
                    <Button onClick={actionSelectFilter}><i className="fa-solid fa-xmark" /></Button>
                </Modal.Header>
                <Modal.Body style={{
                    maxHeight: 'calc(100vh - 210px)',
                    overflowY: 'auto'
                }}>
                    <Form>
                        <Form.Label>{t("file_format")}</Form.Label>
                        <Row>
                            <Col xl={6}>
                                <Form.Group className="mb-3">

                                    <div className="mb-3">
                                        <Form.Check
                                            value="daily"
                                            type="radio"
                                            aria-label="radio 1"
                                            label={"PDF"}
                                            checked={pdfChecked}

                                            onChange={(e) => {
                                                setpdfChecked(true);
                                                setcsvChecked(false);

                                            }}
                                        />

                                    </div>
                                </Form.Group>
                            </Col>
                            <Col xl={6}>
                                <Form.Group className="mb-3">
                                    <div className="mb-3">
                                        <Form.Check
                                            value="monthly"
                                            type="radio"
                                            aria-label="radio 2"
                                            label={"CSV"}
                                            checked={csvChecked}
                                            onChange={(e) => {
                                                setpdfChecked(false);
                                                setcsvChecked(true);

                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        <>{/*
                            <Form.Label>{t("select_filter_type")}</Form.Label>
                            <Row>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("departure_date")}
                                            value="DEPARTUREDATE"
                                            checked={selectedFilter === 'DEPARTUREDATE'}
                                            onChange={() => setSelectedFilter('DEPARTUREDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("issue_date")}
                                            value="ISSUEDATE"
                                            checked={selectedFilter === 'ISSUEDATE'}
                                            onChange={() => setSelectedFilter('ISSUEDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("boarding_date")}
                                            value="BOARDINGDATE"
                                            checked={selectedFilter === 'BOARDINGDATE'}
                                            onChange={() => setSelectedFilter('BOARDINGDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>*/}
                        </>
                        <Row>
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("select_start_date")}</Form.Label>
                                    <Form.Control onChange={(e) => {
                                        e.persist();

                                        setDateFrom(e.target.value);
                                        setshowCompany(false)


                                    }} type="date" value={dateFrom !== "" ? dateFrom : ""} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row hidden={showCompany}>
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("company")}</Form.Label>
                                    <Form.Select size="lg" onChange={(e) => setTypeCompany(e)}>
                                        <option key="value_null">-- {t("select")} --</option>
                                        {companies.map((item, idx) => (
                                            renderOption2(item, idx)
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row hidden={showDeparturePort}>
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("port")}</Form.Label>
                                    <Form.Select size="lg" onChange={(e) => setTypeDeparture(e)}>
                                        <option key="value_null">-- {t("select")} --</option>
                                        {ports.map((item, idx) => (
                                            renderOptionPortDeparture(item, idx)

                                        ))}
                                    </Form.Select>

                                </Form.Group>
                            </Col>
                        </Row>





                    </Form>
                </Modal.Body>
                {
                    typologyReport === "daily" ?
                        <Form style={{
                            marginLeft: '15px',
                            marginBottom: '10px',
                            marginTop: '-10px'
                        }}>
                            <Row>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <p>{t("select_start_date")}</p>
                                        <Form.Control style={{ width: "50%" }} onChange={(e) => {
                                            handleChange(e);
                                            setDateOfDay(e.target.value);
                                        }} type="date" value={dateOfDay !== "" ? dateOfDay : ""} />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                        : null
                }
                {
                    typologyReport === "monthly" ?
                        <Form style={{
                            marginLeft: '15px',
                            marginBottom: '10px',
                            marginTop: '-10px'
                        }}>
                            <Row>
                                <Col xl={12}>
                                    <p>{t("select_month_year")}</p>
                                    <DatePicker locale={it}
                                        selected={dateOfMonth === null ? new Date() : dateOfMonth}
                                        onChange={(date) => setDateOfMonth(date)}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                        showFullMonthYearPicker
                                        showTwoColumnMonthYearPicker />
                                </Col>
                            </Row>
                        </Form>
                        : null
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={actionReset}>
                        {t("reset")}
                    </Button>
                    <Button disabled={disableButton} variant="primary" onClick={actionApply}>
                        {t("apply")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Row hidden={showDocument}>

                {

                    Document !== null ?
                        (

                            <Col xl={12}>
                                <div className="pb-70">
                                    <Card>
                                        <Card.Body>
                                            <object width="100%" height="600"
                                                data={Document}
                                                type="application/pdf"></object>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>


                        )
                        : null
                }
            </Row>
        </div>
    )
};

export default ReportFilterPortDues;
